export function objectToArray(obj) {
    const arr = [];
    const keys = Object.keys(obj);
    for (const key of keys) {
        //@ts-ignore
        arr.push(obj[key]);
    }
    return arr;
}
